// in src/App.js
import React from 'react';
import firebase from 'firebase';
import  {GetOneService}  from './services';
import {
  Admin,
  Resource,
  resolveBrowserLocale
  //permissions
} from 'react-admin';

import {
  MissionsList,
  MissionShow,
  MissionEdit,
  MissionCreate,
  // ContributionsList,
  // ContributionsEdit,
  UsersList,
  UserShow,
  UserEdit,
  CompaniesList,
  CompanyShow,
  CompanyEdit,
  Title,
  EventsList,
  EventShow,
  EventEdit
  // Dashboard
} from 'components';

import ContributionsList from './components/Contributions';
import MyLoginPage from './components/login/MyLoginPage';
import MyLogoutButton from '../src/components/login/MyLogoutButton';

import { AuthProvider, DataProvider } from 'providers';

import englishMessages from 'ra-language-english';
import frenchMessages from 'ra-language-french';
import frDomainMessages from './i18n/translation_fr.json';
import enDomainMessages from './i18n/translation_en.json';

//import state from './contributions/contributionReducer';

//import icons from https://material.io/tools/icons/?style=baseline
import MissionIcon from '@material-ui/icons/GroupWork';
import UsersIcon from '@material-ui/icons/People';
import CompaniesIcon from '@material-ui/icons/BusinessCenter';
import EventsIcon from '@material-ui/icons/Terrain';

import { createMuiTheme } from '@material-ui/core/styles';
// import indigo from "@material-ui/core/colors/indigo";
// import pink from "@material-ui/core/colors/pink";
// import blue from "@material-ui/core/colors/blue";
import grey from '@material-ui/core/colors/grey';
import green from '@material-ui/core/colors/green';
// import lightGreen from "@material-ui/core/colors/lightGreen";
import red from '@material-ui/core/colors/red';
import AphLayout from './components/AphLayout';

const theme = createMuiTheme({
  palette: {
    type: 'light', // Switching the dark mode on is a single property value change.
    primary: green,
    secondary: {
      main: grey[700]
    },
    error: red,
    contrastThreshold: 3,
    tonalOffset: 0.2
  },
  typography: {
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      'Roboto',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Arial',
      'sans-serif'
    ].join(',')
  },
  overrides: {
    MuiButton: {
      // override the styles of all instances of this component
      root: {
        // Name of the rule
        color: 'white' // Some CSS
      }
    }
  }
});

const messages = {
  fr: { ...frenchMessages, ...frDomainMessages },
  en: { ...englishMessages, ...enDomainMessages }
};
const i18nProvider = locale => messages[locale];

class App extends React.Component {
  state = {
    username: null,
    userId: null,
  };
  componentWillMount() {
    var config = {
      apiKey: 'AIzaSyD_yElrIbamlkQ2HR8tpQXWMqiKlKUS244',
      authDomain: 'apholygie-927d1.firebaseapp.com',
      databaseURL: 'https://apholygie-927d1.firebaseio.com',
      projectId: 'apholygie-927d1',
      storageBucket: 'apholygie-927d1.appspot.com',
      messagingSenderId: '953325869996'
    };
    firebase.initializeApp(config);
  }

  componentDidMount() {
     firebase.auth().onAuthStateChanged(user => {
      if (user) this.setState({
         username: user.displayName,
         userId: user.uid,
         emailPicture: user.photoURL,
         });
         const id = user.uid;
         const getOneService = new GetOneService();
         getOneService.getOneUser('users', id)
         .then(user => this.setState({
          userPhoto : user && user.photoURL,
         }));
    });
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  render() {
    const { username, userId, userPhoto, emailPicture } = this.state;
    const photoURL = userPhoto ? userPhoto : emailPicture;
    return (
      <Admin
        title={<Title />}
        loginPage={props => <MyLoginPage {...props} theme={theme} />}
        logoutButton={props => <MyLogoutButton {...props} username={username} userId={userId} emailPicture={emailPicture} userPhoto={userPhoto} photoURL={photoURL}/>}
        appLayout={AphLayout}
        theme={theme}
        locale={resolveBrowserLocale()}
        i18nProvider={i18nProvider}
        dataProvider={DataProvider}
        // dashboard={Dashboard}
        authProvider={AuthProvider}
      >
        {permissions => {
          return [
            <Resource
              name="missions"
              list={MissionsList}
              show={MissionShow}
              create={permissions > 0 ? MissionCreate : null}
              options={{ roleLevel: permissions }}
              edit={permissions > 0 ? MissionEdit : null}
              icon={MissionIcon}
            />,
            <Resource
              name="contributions"
              options={{ roleLevel: permissions }}
              list={ContributionsList}
              // edit={ContributionsEdit}
            />,
            <Resource
              name="events"
              list={EventsList}
              show={EventShow}
              options={{ roleLevel: permissions }}
              edit={permissions > 0 ? EventEdit : null}
              icon={EventsIcon}
            />,
            <Resource
              name="users"
              list={UsersList}
              show={UserShow}
              options={{ roleLevel: permissions }}
              edit={permissions > 0 ? UserEdit : null}
              icon={UsersIcon}
            />,
            <Resource
              name="companies"
              list={CompaniesList}
              show={CompanyShow}
              options={{ roleLevel: permissions }}
              edit={permissions > 0 ? CompanyEdit : null}
              icon={CompaniesIcon}
            />
            // <Resource
            //   name="companies"
            //   list={CompaniesList}
            //   show={CompanyShow}
            //   options={{ roleLevel: permissions }}
            //   edit={permissions > 0 ? CompanyEdit : null}
            //   icon={CompaniesIcon}
            // />
          ];
        }}
      </Admin>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js